import axios from 'axios'

// 配置基础URL（根据实际环境调整）


// 请求拦截器（可选，根据需要添加）



/**
 * SeckillController 相关接口
 */
export default {
  /**
   * 参与秒杀
   * @param {Object} data - 秒杀数据
   * @param {number} data.userId - 用户ID
   * @param {number} data.productId - 商品ID
   * @param {number} data.activityId - 活动ID
   * @param {number} data.count - 购买数量(通常为1)
   * @param {number} data.isSeckill - 1(固定为1)
   * @returns {Promise} - 订单编号
   */
  doSeckill(data) {
    return axios({
      url: '/product-service/api/seckill/createSeckill',
      method: 'post',
      data
    })
  },
  
  /**
   * 获取当前秒杀活动
   * @returns {Promise} - 秒杀活动列表
   */
  getCurrentSeckillActivities() {
    return axios({
      url: '/product-service/api/seckill/activities',
      method: 'get'
    })
  },
  

  
  /**
   * 检查秒杀资格
   * @param {number} activityId - 活动ID
   * @param {number} userId - 用户ID
   * @returns {Promise} - 资格检查结果
   */
  checkSeckill(activityId, userId) {
    return axios({
      url: '/api/seckill/check',
      method: 'get',
      params: { activityId, userId }
    })
  },
  
  /**
   * 获取秒杀订单状态
   * @param {string} orderSn - 订单编号
   * @returns {Promise} - 订单状态
   */
  getSeckillOrderStatus(orderSn) {
    return axios({
      url: '/api/seckill/order/status',
      method: 'get',
      params: { orderSn }
    })
  }
}
